import Vue from 'vue'
import Vuex from 'vuex'

import {task} from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    assignment: null,
    assignments: [],
    continue_chapter: false,
    show_chapter_intro: true,
    video_played: false,
    isPreview: false,
    taskCode: null,
    slug: null,
    isCompleted: false
  },
  mutations: {
    setAssignment(state, assignment) {
      state.assignment = assignment
    },
    setAssignments(state, assignments) {
      state.assignments = assignments
    },
    setSlug(state, slug) {
      state.slug = slug
    },
    setChapterFlag(state, value) {
      state.continue_chapter = value
    },
    setShowChapterIntro(state, value) {
      state.show_chapter_intro  = value
    },
    setVideoPlayed(state, value) {
      state.video_played = value;
    },

    setSubmission(state, newSubmission) {
      let assignment = state.assignment
      assignment.submission = newSubmission
      state.assignment = assignment
    },
    setIsPreview(state, preview) {
      state.isPreview = preview
    },
    setTaskCode(state, code) {
      state.taskCode = code
    },
    setIsCompleted(state, value) {
      state.isCompleted = value
    }
  },
  actions: {
    loadAssignment({commit}, slug) {
      if (slug.indexOf('preview-') == 0) {
        let id = parseInt(slug.replace('preview-', ''))
        return task.getTask(id)
          .then(response => {
            if (response.task) {
              let chapter = response.task.chapter || {}
              let assignment = {
                task: response.task,
                student: {
                  name: '',
                  email: ''
                },
                chapter: chapter,
                submission: {},
                slug: slug,
                status: 'active'
              }
              commit('setAssignment', assignment)
              commit('setChapterFlag', false)
              commit('setIsPreview', true)
            }
          })
      }
      return task.getAssignment(slug)
        .then(response => {
          if (response.assignment) {
            commit('setAssignment', response.assignment)
            //commit('setShowChapterIntro', false)
          }
        })
    },

    validateTaskCode({commit}, code) {
      return task.validateCode(code)
        .then(response => {
          if (response.taskCode.success) {
            commit('setTaskCode', code)
          }
        })
    },

    disableChapter({commit}) {
      return commit('setChapterFlag', false)
    },

    SelectNextTask({commit}) {
      if (this.state.assignments.length > 0)  {
        commit('setAssignment', this.state.assignments.shift())
        commit('setAssignments', this.state.assignments)
      } else {
        commit('setChapterFlag', false)
      }
    },

    loadAssignments({commit}, slug) {
      if (slug.indexOf('preview-') == 0) {
        return this.dispatch('loadAssignment', slug)
      }
      return task.getAssignments(slug)
        .then(response => {
          if (response.assignments.length > 0){
            if (response.assignments[0]) {
              commit('setChapterFlag', true)
            }
            commit('setAssignment', response.assignments.shift())
            commit('setAssignments', response.assignments)
          } else {
            this.dispatch("loadAssignment", slug)
          }
        })
    },

    submitAssignment({state, commit}, completed = false) {
      if (state.isPreview) {
        return Promise.resolve()
      }
      let slug = state.assignment.slug
      let submission = JSON.stringify(state.assignment.submission)
      return task.submitAssignment(slug, submission, completed)
        .then(response => {
          commit('setAssignment', response.submitAssignment)
        })
    },

    submitUsername({state, commit}, username = "") {
      if(state.taskCode) {
        return task.submitUsername(state.taskCode, username)
          .then(response => {
            commit('setIsCompleted', response.submitUsername.class_task.status)
            commit('setSlug', response.submitUsername.slug)
          })
      }
    },

    getVideoEmbed(commit, video_url) {
      return task.getVimeoVideo(video_url)
    }
  }
})
